import React from 'react';
import { useCanManageTemplates, useSelectedTemplatingItem } from '../../hooks';
import { IconButton } from '@lifeomic/chroma-react/components/IconButton';
import { Plus } from '@lifeomic/chromicons';
import { useSaveCompositeReportDefinition } from '../../hooks/useSaveCompositeReportDefinition';
import { TemplateSummary } from '../../models';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  addTemplateSummaryToCRD: {
    id: 'AddTemplateSummaryToCRD.addTemplateSummaryToCRD',
    defaultMessage: 'Add Template Summary to Composite Report Template',
  },
});

type AddTemplateSummaryToCRDProps = {
  template: TemplateSummary;
};

export const AddTemplateToCRD = ({
  template,
}: AddTemplateSummaryToCRDProps) => {
  const {
    selectedTemplatingItemQuery: { data: selectedTemplatingItem },
  } = useSelectedTemplatingItem();
  const { save } = useSaveCompositeReportDefinition();
  const { formatMessage } = useIntl();
  const canManageTemplates = useCanManageTemplates();

  if (
    !canManageTemplates ||
    selectedTemplatingItem?.type !== 'compositeReportDefinition'
  ) {
    return null;
  }

  const hasTemplateSummary = selectedTemplatingItem.sections.some(
    section => section.templateId === template.durableId,
  );

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();

    if (hasTemplateSummary) return;

    return save(selectedTemplatingItem, {
      sections: [
        ...selectedTemplatingItem.sections,
        { templateId: template.durableId },
      ],
    });
  };

  return (
    <IconButton
      aria-label={formatMessage(messages.addTemplateSummaryToCRD)}
      icon={Plus}
      onClick={handleClick}
      size={0}
      color="inverse"
    />
  );
};
